export default __webpack_public_path__ + "static/media/aliyun.3b19c8e5.svg";